var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":"انتخاب حساب","size":"md","ok-only":"","ok-title":"تایید"},on:{"ok":_vm.onOk}},[_c('accounts-titles',{on:{"selectAccountTitle":_vm.selectAccountTitle,"dblClicked":_vm.dblClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }